import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "toggle"]

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.toggleTarget.textContent = "Hide"
    } else {
      this.hidePassword()
    }
  }

  hidePassword() {
    this.inputTarget.type = "password"
    this.toggleTarget.textContent = "Show"
  }

  disconnect() {
    this.hidePassword()
  }
}
